if (!window.__tileGridExpandBound) {
  window.__tileGridExpandBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tile-grid-expand]');
    if (!btn) return;

    var list = document.getElementById(btn.getAttribute('data-tile-grid-expand'));
    if (!list) return;

    var expanded = list.classList.contains('tile-grid--expanded');

    if (expanded) {
      var savedClasses = (list.dataset.tileGridSliderClasses || '').split(' ').filter(Boolean);
      savedClasses.forEach(function (cls) {
        list.classList.add(cls);
      });
      list.classList.remove('tile-grid--expanded');
      btn.textContent = btn.getAttribute('data-view-all-label');
    } else {
      var sliderClasses = ['slider', 'slider--mobile', 'slider--tablet-up'].filter(function (cls) {
        return list.classList.contains(cls);
      });
      list.dataset.tileGridSliderClasses = sliderClasses.join(' ');
      sliderClasses.forEach(function (cls) {
        list.classList.remove(cls);
      });
      list.classList.add('tile-grid--expanded');
      btn.textContent = btn.getAttribute('data-view-less-label');
    }
  });
}
